export default {
  relatedUuid: {},
  selectedRepository: {},
  repositoryVersion: null,
  repositoryVersionName: null,
  updateRepository: false,
  updateVersions: false,
  repositoryIsTraining: false,
  requirements: {},
  publicIntelligences: {
    limit: 40,
    offset: 0,
    data: [],
    next: null,
    status: null,
  },
  current: {},
};
